import React from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Trophy, BadgeCheck, Banknote, Receipt, Tag, Star, Settings, ScrollText, ArrowLeft, Megaphone, FileText, Rocket, SlidersHorizontal, Users, Search, BarChart3, ShieldAlert, FlaskConical, Landmark, Disc3, Gift, Clapperboard } from "lucide-react";

const items = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/site-control", label: "Site Control", icon: SlidersHorizontal },
  { to: "/admin/launch", label: "Site Launch", icon: Rocket },
  { to: "/admin/competitions", label: "Competitions", icon: Trophy },
  { to: "/admin/marketing", label: "AI Marketing", icon: Megaphone },
  { to: "/admin/hero-studio", label: "Animated Heroes", icon: Clapperboard },
  { to: "/admin/pricing-lab", label: "AI Pricing Lab", icon: FlaskConical },
  { to: "/admin/seo", label: "AI SEO", icon: Search },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3 },
  { to: "/admin/finance", label: "Finance & Tax", icon: Landmark },
  { to: "/admin/spin-wheel", label: "Spin Wheel", icon: Disc3 },
  { to: "/admin/content", label: "Content & Legal", icon: FileText },
  { to: "/admin/verifications", label: "Verifications", icon: BadgeCheck },
  { to: "/admin/cashouts", label: "Cash-outs", icon: Banknote },
  { to: "/admin/expenses", label: "Expenses", icon: Receipt },
  { to: "/admin/discounts", label: "Discounts", icon: Tag },
  { to: "/admin/subscriptions", label: "Subscriptions", icon: Star },
  { to: "/admin/referrals", label: "Refer a Friend", icon: Gift },
  { to: "/admin/security", label: "Security & Risk", icon: ShieldAlert },
  { to: "/admin/staff", label: "Staff & Roles", icon: Users },
  { to: "/admin/settings", label: "Settings", icon: Settings },
  { to: "/admin/audit-logs", label: "Audit Logs", icon: ScrollText },
];

export default function AdminLayout() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6">
      <div className="flex items-center justify-between">
        <h1 className="font-display uppercase text-3xl text-white glow-pink">Admin Vault</h1>
        <Link to="/" className="flex items-center gap-2 text-sm text-[var(--text-muted)] hover:text-white"><ArrowLeft className="h-4 w-4" /> Back to site</Link>
      </div>
      <div className="mt-5 grid lg:grid-cols-[260px_1fr] gap-6">
        <aside className="lg:sticky lg:top-20 lg:self-start">
          <nav className="flex lg:flex-col gap-1 overflow-x-auto rounded-xl border border-white/10 bg-[var(--surface)] p-2">
            {items.map((it) => (
              <NavLink key={it.to} to={it.to} end={it.end} data-testid={`admin-nav-${it.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={({ isActive }) => `flex items-center gap-3 whitespace-nowrap rounded-lg px-3 py-2.5 text-sm transition-colors ${isActive ? "bg-[rgba(255,45,149,.12)] text-[var(--neon-pink)]" : "text-[var(--text-muted)] hover:bg-white/5 hover:text-white"}`}>
                <it.icon className="h-4 w-4" /> {it.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <section data-testid="admin-content"><Outlet /></section>
      </div>
    </div>
  );
}
